import React, {useEffect, useState} from 'react'
import { Link } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import Footer from "../components/includes/Footer";
import TopChildrenStatus from "../components/includes/TopChildrenStatus";
import SelectChildrens from "../components/popups/SelectChildrens";
import { ChangeSimpleDateString,LoginAfterCheckLogin,isNull,isObjEmpty,GetMonthDateString } from "../../components/common/Common";

import calendarIcon from "../../img/icon/icon-calendar.svg";
import kidsIcon from "../../img/icon/icon-kids.svg";
import main01Icon from "../../img/icon/icon-center-main01.svg";

const Analysis = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem('mem_idx'));

  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //정보저장변수
  const [varChildrenInfo,setChildrenInfo] = useState({});
  const [varChildrenList,setChildrenList] = useState([]);
  const [varChildrenIndex,setChildrenIndex] = useState(0);
  const [varClassList,setClassList] = useState([]);

  //원생정보호출
  const GetChildrenList = async() => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_member_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) {
          const parents = datas.results;
          setChildrenList(parents);

          //원생 선택
          const childInfo = parents.find(el=>el.ch_idx===varChildrenIndex);
          setChildrenInfo(childInfo);

          GetClassListForChildren();
        }
      } else {
        alert(datas.message);
      }
    });
  }

  //원생별 수업현황 목록 호출
  const GetClassListForChildren = async() => {
    const sendData = {ch_idx:varChildrenIndex,cl_state:2};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_class_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setClassList(datas.results);
      } else {
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});

    //원생고유번호
    let ch_idx = 0;
    if(!isNull(localStorage.getItem('childrenIndex'))) ch_idx = Number(localStorage.getItem('childrenIndex'));
    setChildrenIndex(ch_idx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(varChildrenIndex > 0) GetChildrenList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varChildrenIndex]);

  //원생선택 팝업창--------------------------------------------------------
  const [varPopupChildrens,setPopupChildrens] = useState(false);
  const onChangeChildrenHandler = (e) => {
    setPopupChildrens(true);
  }
  const ClosePopupChildrens = () => {
    setPopupChildrens(false);
  }
  const SelectChildrenHandler = (ch_idx) => {
    console.log(ch_idx);
    setPopupChildrens(false);
    //원생선택
    setChildrenIndex(ch_idx);
    localStorage.setItem('childrenIndex',ch_idx);
  }

  return (
    <div className="vh-content">
      <div className="vh-content-body" style={{paddingTop:"5px"}}>
        {/* 원생정보 */}
        {isObjEmpty(varChildrenInfo)?null:<TopChildrenStatus varClasses={'user-info'} varChildrenInfo={varChildrenInfo} varChildrenList={varChildrenList} onChangeChildrenHandler={onChangeChildrenHandler} />}
        {/* 수업현황 */}           
        <div className="class-sec01">
          <div className="center-wrap">
            <p className="sec-tit">발달분석/평가 현황</p>
            {varClassList.length === 0?
              <div className="class-box st02">
                <p>발달분석/평가된 내역이 없습니다.</p>
              </div>
            :varClassList.map((classes,i)=>(
              <div key={'classes_'+i} className="class-box st02">
                <div className="class-line">
                  <div>수업 차수 {classes.ecount+classes.xcount}/{classes.tcount}</div>
                  <div>출석 {classes.ecount}</div>
                  <div>결석 {classes.xcount}</div>
                </div>
                <div className="class-con">
                  <div className="img-box">
                    <Link to={`/Parents/ClassStudy/${classes.ch_idx}/${classes.cl_idx}`}>
                      <img src={main01Icon} alt=""/>
                      <span>{classes.cl_type===1?"마마몽떼":"플라이"}<br/>{classes.cr_name}</span>
                    </Link>
                  </div>
                  <div className="txt-box">
                    <p className="class-tit">{classes.cl_name}</p>
                    <div className="class-date">
                      <img src={calendarIcon} alt=""/>
                      <p>{ChangeSimpleDateString(classes.sm_sdate)} ~ {GetMonthDateString(classes.sm_edate)}</p>
                    </div>
                    <div className="class-kids">
                      <img src={kidsIcon} alt=""/>
                      <p>{classes.vl_name} ({classes.ch_attendance})</p>
                    </div>
                  </div>
                </div>
                <div className="btn-wrap">
                  <Link to={classes.cl_type===1?
                            `/Parents/AnalysisMonte/${classes.clc_idx}`
                            :`/Parents/AnalysisFly/${classes.clc_idx}`} className="btn-yes">
                    {classes.cl_type===1?"MDT 발달분석평가":"플라이 진도표"}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer varCurrentPage={2}/>
      <SelectChildrens varChildrenIndex={varChildrenIndex} varPopupChildrens={varPopupChildrens} varChildrenList={varChildrenList} ClosePopupChildrens={ClosePopupChildrens} SelectChildrenHandler={SelectChildrenHandler}/>
    </div>
  )
}
export default Analysis;